import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";

const PublicRoute: React.FC = () => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (isAuthenticated) {
    // Redirect based on user role
    if (user?.role === "SuperAdmin") {
      return <Navigate to="/tenants" replace />;
    } else if (user?.role === "TruckDriver") {
      return <Navigate to="/truck-driver" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export default PublicRoute;

